<template>
    <div >
        <div  class="container-fluid">
    <div style="border-bottom: 0px; padding-top: 0px;" class="navbar">
    
    <div class="d-flex  ">
    
    </div>
    <div class="d-flex  ">
     


      <template>
  <div class="dropdown">
    <a style="background-color: white;color: rgb(71, 144, 255);"
      class="btn btn-primary dropdown-toggle"
      type="button"
      id="dropdownMenuButton1"
      data-toggle="dropdown"
      aria-expanded="false"
    >
      {{ selectedLanguageName }}
  </a>
    <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
      <li
        v-for="lang in lans"
        :key="lang.id"
        @click="selectLanguage(lang)"
        class="dropdown-item"
        style="cursor: pointer"
      >
        {{ lang.language_name }}
      </li>
    </ul>
  </div>
</template>





      
    </div>
    </div>
          
      <br>
        <div class="row top-mrgg1">
          <div class="col-md-6 ">
              <div class="left-mrgg1 mt-4">
              <img class="mb-2" src="../../assets/evenware-logo.png" width="140" alt="">
              <h6 style="font-size: large;">{{details[138]['Welcome to the Demonstration System']}} </h6>
              <p style="font-size: x-small;">
                {{details[98]['Warning']}}: {{details[126]['All users of this system are traceable and any unauthorised usage is prohibited']}}.
              </p>
              </div>
          </div>
          <div  class="col-md-6 margin2">
            <div class="bdr1 card bdr-rad2">
              <p class="authorization bdr-rad">{{details[96]['Authorization']}}</p>

              <div class="">
                <input v-model="login.username" :placeholder="details[60]['Username']" class="form-control input5 input6 bdr-rad">
                <input type="password" v-model="login.password" :placeholder="details[94]['Password']" class="form-control input5 bdr-rad">
                
               
                <b-button v-on:click="Login()" style="background-color: rgb(71, 144, 255);color: white;" class="btn  login1 bdr-rad">{{details[95]['Login']}}</b-button>
                
              </div>
            </div>
          </div>

        </div>
    </div>

        <ContentFooter2></ContentFooter2>
    </div>
</template>
<script>
  import ContentFooter2 from './../../layout/ContentFooter2.vue'
  import authService from './../../auth.service';
  import axios from 'axios';
  import vSelect from 'vue-select'




  export default  {
    data(){
return {
  language:JSON.parse(authService.isLanguage()),
  languageid:authService.isLanguageid(),
  languagename:authService.isLanguagename(),
  selectedLanguageName: "Select Language",
    errors:'',
    lans:[],
    details:[],
    errors2:'',
    'login':{
              'username':'',
              'password':'',
            }
}
    },

    created(){
      this.loadlanguage();
      this.loadlan();
    },
    components:{
        ContentFooter2,
        'v-select': vSelect,

    },
    methods: {

      


      async loadlan() {
        
   
   
        try {
          const { data} = await  axios.get('/user/loadlan',{
            headers:{
              // 'Authorization':'Bearer '+this.access_token,
              'Content-type': 'application/json',
             
            }
           });
           console.log(data);
          
           this.lans = data.lans;
          
          
           
           
          
        } catch (error) {
          console.log(error.response);
        }
      },


      async loadlanguage() {
        if (this.languageid === undefined || this.languageid === null) {
          this.languageid = 1;
        }
        console.log("lan_id");
   console.log(this.languageid);
    try {
      const { data} = await  axios.post('/user/loadlanguage1',{languageid:this.languageid},{
        headers:{
          // 'Authorization':'Bearer '+this.access_token,
          'Content-type': 'application/json',
         
        }
       });
       console.log(data);
      
       this.details = data.details;
      //  localStorage.setItem('LANGUAGE', JSON.stringify(details));
       if(this.languagename === undefined || this.languagename === null){
        this.selectedLanguageName = "Select Language";
       }else{
        this.selectedLanguageName = this.languagename;
       }
      

     
       
       
      
    } catch (error) {
      console.log(error.response);
    }
  },


  async selectLanguage(lang) {

console.log(lang.id);

localStorage.setItem('LANGUAGEID', lang.id);
localStorage.setItem('LANGUAGENAME', lang.language_name);
this.selectedLanguageName = lang.language_name;

this.loadlanguage2(lang.id);


},

  async loadlanguage2(id) {
       
        console.log("lan_id");
   console.log(id);
    try {
      const { data} = await  axios.post('/user/loadlanguage1',{languageid:id},{
        headers:{
          // 'Authorization':'Bearer '+this.access_token,
          'Content-type': 'application/json',
         
        }
       });
       console.log(data);
      
       this.details = data.details;
       //localStorage.setItem('LANGUAGE', JSON.stringify(details))
       window.location.reload();
       
       
      
    } catch (error) {
      console.log(error.response);
    }
  },

        async  Login() {
      // console.log("here we are",this.errorlist); check karaganimata awashya we
       console.log(this.login);
       const {success,errors,errors2} = await authService.Login(this.login,this.languageid);
       if(success){
        if (authService.isDemoUser()) {
          this.$router.push('/pdf/create7');
        } else if (authService.isCrcUser()) {
          this.$router.push('/projectmanagement/visitindex');
        } else if (authService.isQuickserveUser()) {
          this.$router.push('/quickserve/restaurantindex');
        } else {
          this.$router.push('/');
        }
        window.location.reload();
       }
       else{
        this.errors = errors;
        this.errors2 = errors2;
       }
       
       
          
          
      //      //window.location.reload();
          
        
        
   

    },

    },





  }
</script>
<style scoped>
.btn {
    border-width: 0px;
}
input::placeholder {
  color: gray;
}

.form-control {
    height:40%;
}


@media only screen and (min-width: 768px) {
  .left-mrgg1{
  margin-left: 30%;
  


}
.top-mrgg1{
  margin-top: 50px
}


.bdr1{
  padding: 30px 10px 60px 10px;
  width: 408px;
  margin-left: 7%;
}
.login1{
  width: 365px;
  font-size: small;
  margin-left: 8px;
  margin-top: 14px;
}
.input5{
  width: 365px;
  font-size: small;
  margin-left: 8px;
  margin-top: 8px;
 
}
.input6{
  margin-top: 25px;
}
.authorization{
  background-color: #f5f5f5;
  width: 380px;
  padding: 5px;
  padding-left: 15px;

}

}







@media only screen and (max-width: 768px) {

.left-mrgg1{
  text-align: center;
}

.bdr1{
  padding: 30px 10px 50px 10px;
  width: 340px;
  margin: 0 auto;
}

.login1{
  width: 300px;
  font-size: small;
  margin-left: 8px;
  margin-top: 14px;
}

.input5{
  width: 300px;
  font-size: small;
  margin-left: 8px;
  margin-top: 8px;
}

.input6{
  margin-top: 25px;
}

.authorization{
  background-color: #f5f5f5;
  width: 315px;
  padding: 5px;
  padding-left: 15px;
  border-radius: 4px;
}

}









</style>
